import { EarnPoints, InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import LimitSeturPointsEarnTooltip from '@components/views/components/LimitEarningSeturPointsBadge/LimitEarnTooltip';
import { FlexibleDiv } from '@components/formStyles';

import { LoyaltyDiscountBadge, LoyaltyText } from './LoyaltyBadgeStyle';

type LoyaltyEarnBadgeType = {
  discount: number;
  earn: number;
  showMaxLoyaltyEarn?: boolean;
};
const LoyaltyEarnBadge = ({
  discount,
  earn,
  showMaxLoyaltyEarn,
}: LoyaltyEarnBadgeType) => {
  return discount && earn ? (
    <>
      <LoyaltyDiscountBadge>
        <CustomIcon fontSize={16} icon={EarnPoints} paletteColor='white' />
        <LoyaltyText>
          {`%${discount} (${earn} ₺) Setur Puan Kazanma Fırsatı`}
        </LoyaltyText>

        {showMaxLoyaltyEarn ? (
          <LimitSeturPointsEarnTooltip>
            <FlexibleDiv left={8} top={-2}>
              <CustomIcon
                icon={InfoIcon}
                fontSize={17}
                paletteColor='B400'
                clickable
              />
            </FlexibleDiv>
          </LimitSeturPointsEarnTooltip>
        ) : null}
      </LoyaltyDiscountBadge>
    </>
  ) : null;
};

export default LoyaltyEarnBadge;
